export class Logger {
	static loglevel = null;

	static LEVEL_DEBUG = 1;
	static LEVEL_INFO = 2;
	static LEVEL_NOTICE = 3;
	static LEVEL_WARNING = 4;
	static LEVEL_ERROR = 5;
	static LEVEL_CRITICAL = 6;
	static LEVEL_ALERT = 7;
	static LEVEL_EMERGENCY = 8;

	static setLogLevel(level = Logger.LEVEL_WARNING) {
		Logger.logLevel = level;
	}

	static debug(message) {
		log(Logger.LEVEL_DEBUG, message);
	}

	static info(message) {
		log(Logger.LEVEL_INFO, message);
	}

	static notice(message) {
		log(Logger.LEVEL_NOTICE, message);
	}

	static warning(message) {
		log(Logger.LEVEL_WARNING, message);
	}

	static error(message) {
		log(Logger.LEVEL_ERROR, message);
	}

	static critical(message) {
		log(Logger.LEVEL_CRITICAL, message);
	}

	static alert(message) {
		log(Logger.LEVEL_ALERT, message);
	}

	static emergency(message) {
		log(Logger.LEVEL_EMERGENCY, message);
	}
}

function log(level, message) {
	if(level < Logger.logLevel) {
		return;
	}

	console.log(message);
}
